"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var Players_module_css_1 = __importDefault(require("./Players.module.css"));
var react_i18next_1 = require("react-i18next");
var IsOnline = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var record = (0, react_admin_1.useRecordContext)();
    if (record.device_type_id === 1) {
        return (React.createElement("span", { className: props.view === "grid"
                ? Players_module_css_1.default.web_player_status_grid_container
                : props.view === "list" && Players_module_css_1.default.web_player_status_list_container }, t("Web")));
    }
    return record.is_online ? (React.createElement("span", { className: props.view === "grid"
            ? Players_module_css_1.default.online_player_status_grid_container
            : props.view === "list" && Players_module_css_1.default.online_player_status_list_container }, t("Online"))) : (React.createElement("span", { className: props.view === "grid"
            ? Players_module_css_1.default.offline_player_status_grid_container
            : props.view === "list" && Players_module_css_1.default.offline_player_status_list_container }, t("Offline")));
};
exports.default = IsOnline;
